<template>
  <pl-dialog
    :header="'Edit User Email'"
    :headerStyle="'font-size: 24px; font-weight: bold'"
    :max-width="'600px'"
    :padding="'2em'"
  >
    <pl-input
      v-model="email_edited"
      :labelText="'User Email'"
      :placeholder="'edit user email'"
    />
    <div class="error-message">
      {{ error_message }}
    </div>
    <div class="row mt3 center-xs">
      <pl-button @click.native="$emit('close')">
        CANCEL
      </pl-button>
      <pl-button class="pl-primary" @click.native="editUserEmail">
        UPDATE EMAIL
      </pl-button>
    </div>
  </pl-dialog>
</template>
<script>
  import { EventBus } from 'utils/event-bus';
  export default {
    props: {
      user: {
        type: Object,
        default() {
          return {};
        },
      },
    },
    data() {
      return {
        email_edited: '',
        error_message: '',
      };
    },
    methods: {
      isAnEmail(email) {
        var regex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
      },
      editUserEmail() {
        this.error_message = '';
        if (!this.isAnEmail(this.email_edited)) {
          return (this.error_message = 'Invalid Email');
        }
        this.$store
          .dispatch('updateUserEmail', {
            id: this.user.id,
            email: this.email_edited,
          })
          .then((res) => {
            if (res) {
              this.alertToast('Success')();
              this.$emit('update-user-email', res);
              this.$emit('close');
            } else {
              return (this.error_message = 'This Email Exists');
            }
          })
          .catch(() => {
            this.alertToast('Failure');
            this.$emit('close');
          });
      },
      alertToast(msg) {
        return () => {
          EventBus.$emit('toast-msg', msg);
        };
      },
    },
    mounted() {
      this.email_edited = this.user.email;
    },
  };
</script>
<style lang="stylus" scoped>
  .error-message
    color: red
</style>



// WEBPACK FOOTER //
// editUserEmailModal.vue?7453eb60